import { Reducer } from 'redux';

import {
  CheckedUncheckedTopicAction,
  SelectAllTopicsAction,
  UnselectAllTopicsAction,
} from '../../domains/checkedTopicsFromDiscoveryTopics/actions.types';
import { Topic } from '../types';

import { CheckedTopicsFromDiscoveryTopics } from './types';

export type CheckedTopicsFromDiscoveryTopicsAction =
  | CheckedUncheckedTopicAction
  | SelectAllTopicsAction
  | UnselectAllTopicsAction;

const initialState: CheckedTopicsFromDiscoveryTopics = {
  topicIds: [],
  isSelectedAll: false,
};

const checkedUncheckedTopic = (topicId: Topic['id'], state: CheckedTopicsFromDiscoveryTopics) => {
  const { topicIds } = state;
  const isTopicChecked = topicIds.includes(topicId);

  const updatedTopicIds = isTopicChecked
    ? topicIds.filter((checkedTopicId) => checkedTopicId !== topicId)
    : [...topicIds, topicId];

  const isSelectedAll = isTopicChecked ? false : state.isSelectedAll;

  return { topicIds: updatedTopicIds, isSelectedAll };
};

const reducer: Reducer<CheckedTopicsFromDiscoveryTopics, CheckedTopicsFromDiscoveryTopicsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'CHECKED_TOPICS_FROM_DISCOVERY_TOPICS.CHECKED_UNCHECKED_TOPIC':
      return checkedUncheckedTopic(action.payload.topicId, state);
    case 'CHECKED_TOPICS_FROM_DISCOVERY_TOPICS.SELECT_ALL':
      return { topicIds: [...action.payload.topicIds], isSelectedAll: true };
    case 'CHECKED_TOPICS_FROM_DISCOVERY_TOPICS.UNSELECT_ALL':
      return { topicIds: [], isSelectedAll: false };
    default:
      return state;
  }
};

export default reducer;
